import { gql } from '@apollo/client';

export const ALL_ECD_REQUIRED_DOCUMENTS = gql`
  query AllECDRequiredDocuments($registrationTypeId: ID) {
    documents: getAllEcdRequiredDocuments(registrationTypeId: $registrationTypeId) {
      id
      checklistIndex
      checkable
      dependentIndex
      name
      registrationType {
        id
        name
      }
    }
  }
`;
